export default __webpack_public_path__ + "static/media/auth0.22f92631.svg";